/* eslint-disable eqeqeq */
import React, { useState } from "react";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  // faEnvelope,
  faShare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import {
  ActivitySquare,
  // CalendarCheck,
  SearchCheck,
  UserCog2Icon,
} from "lucide-react";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import UserPermission from "../../UserPermission/UserPermission";
import UserActivity from "./UserActivity";
// import moment from "moment";

const UserActionButton = ({
  id,
  setEdit,
  setUserId,
  toggleShowAddEditUser,
  toggleShowDelete,
  userData,
  fetchUser,
  deletedUser,
  toggleShowResend,
  activeUser,
  admin,
  governance,
  amlCTFEnable = false,
  kycAction = false,
  handleSendEmail,
  setOnlyKyc,
}) => {
  const [showPermission, setShowPermission] = useState();

  const toggleShowPermission = () => {
    setShowPermission(!showPermission);
  };

  const [showActivity, setShowActivity] = useState();

  const toggleShowActivity = () => {
    setShowActivity(!showActivity);
  };

  const handleSucess = () => {
    toggleShowPermission();
    fetchUser();
  };

  // const getNextReviewDate = () => {
  //   let assessmentDate = userData?.kyc?.risk_assessment?.assessment_date;
  //   let risk = userData?.kyc?.risk;
  //   if (!assessmentDate) return "N/A";

  //   let yearsToAdd = 0;

  //   if (risk == 0) yearsToAdd = 3;
  //   else if (risk == 1) yearsToAdd = 1;
  //   else if (risk == 2) yearsToAdd = 2;
  //   else return "N/A";

  //   return moment(assessmentDate, "DD-MM-YYYY")
  //     .add(yearsToAdd, "years")
  //     .format("DD-MM-YYYY");
  // };

  return !admin ? (
    <>
      {kycAction ? (
        <span className="flex items-center gap-2 justify-center">
          {/* {userData?.kyc?.risk_assessment && (
            <>
              <CustomTooltip
                message={
                  <div>
                    <p>
                      Assessment Date:{" "}
                      {userData?.kyc?.risk_assessment?.assessment_date}
                    </p>
                    <p>Next Review Date: {getNextReviewDate()}</p>
                  </div>
                }
              >
                <CalendarCheck size={16} />
              </CustomTooltip>
              <span>/</span>
            </>
          )} */}
          <CustomTooltip message={"KYE"}>
            <SearchCheck
              size={16}
              onClick={() => {
                setOnlyKyc(true);
                setEdit(true);
                toggleShowAddEditUser();
                setUserId(id);
              }}
            />
          </CustomTooltip>
        </span>
      ) : (
        <span className="flex items-center gap-2 justify-center">
          {/* {amlCTFEnable ? (
            <>
              {userData?.email !== null ? (
                <CustomTooltip message={"Email"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      size="1x"
                      onClick={() => {
                        !userData?.is_reversed && handleSendEmail(userData?.id);
                      }}
                      className={`${
                        userData?.consent_mail_sent ? "text-green-600" : ""
                      }`}
                    />
                  </span>
                </CustomTooltip>
              ) : (
                <CustomTooltip message={"Email address missing"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      size="1x"
                      disabled
                      className={"opacity-50 cursor-not-allowed"}
                    />
                  </span>
                </CustomTooltip>
              )}
              <span>/</span>
            </>
          ) : (
            <></>
          )} */}
          {!activeUser && (
            <>
              <CustomTooltip message={"Resend Invitation"}>
                <span>
                  <FontAwesomeIcon
                    icon={faShare}
                    size="1x"
                    onClick={() => {
                      setUserId(id);
                      toggleShowResend();
                    }}
                  />
                </span>
              </CustomTooltip>
              <span>/</span>
            </>
          )}
          {!deletedUser && (
            <>
              <CustomTooltip message={"Edit"}>
                <span>
                  <FontAwesomeIcon
                    icon={faEdit}
                    size="1x"
                    onClick={() => {
                      setEdit(true);
                      toggleShowAddEditUser();
                      setUserId(id);
                    }}
                  />
                </span>
              </CustomTooltip>
              <span>/</span>
              <CustomTooltip message={"Delete"}>
                <span>
                  <FontAwesomeIcon
                    icon={faTrash}
                    size="1x"
                    onClick={() => {
                      setUserId(id);
                      toggleShowDelete();
                    }}
                  />
                </span>
              </CustomTooltip>
              <span>/</span>
              <CustomTooltip message={"User Permission"}>
                <span>
                  <UserCog2Icon
                    size={16}
                    onClick={() => {
                      setUserId(id);
                      toggleShowPermission();
                    }}
                  />
                </span>
              </CustomTooltip>
              <span>/</span>
              <CustomTooltip message={"User Activity"}>
                <span>
                  <ActivitySquare
                    size={16}
                    onClick={() => {
                      setUserId(id);
                      toggleShowActivity();
                    }}
                  />
                </span>
              </CustomTooltip>
            </>
          )}
        </span>
      )}

      <ResponsiveDrawerForm
        description={""}
        title={"User Permission"}
        handleOpen={() => {}}
        handleClose={() => {}}
        buttonText={""}
        className={"sm:max-w-[90vw] overflow-hidden"}
        setOpen={setShowPermission}
        open={showPermission}
        popupType={governance ? "governance-summaries" : ""}
        write={true}
      >
        <UserPermission
          expandList={true}
          userId={id}
          userData={userData}
          handleSucess={() => {
            handleSucess();
          }}
        />
      </ResponsiveDrawerForm>

      <ResponsiveDrawerForm
        description={""}
        title={"User Activity"}
        handleOpen={() => {}}
        handleClose={() => {}}
        buttonText={""}
        className={"sm:max-w-[90vw] overflow-hidden"}
        setOpen={setShowActivity}
        open={showActivity}
        write={true}
      >
        <UserActivity expandList={true} userID={id} />
      </ResponsiveDrawerForm>
    </>
  ) : (
    <></>
  );
};

export default UserActionButton;
